<script>
export default {
  props: {
    logo: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    heroDec: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      contactEmail: 'mgm@int-mgm.org',
      contactPhone: '+964 7877799669',
      showLogo: true,
      logoUrl: 'https://api.int-mgm.org/images/settings/45631a34-79e3-44ca-9267-a006e3535625.png'
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
    displayLogo() {
      return this.logo || this.logoUrl;
    }
  },
  methods: {
    handleLogoError() {
      this.showLogo = false;
    }
  }
};
</script>

<template>
  <footer class="footer">
    <!-- Background overlay -->
    <div class="footer-overlay"></div>
    
    <div class="container">
      <!-- Main Footer Content -->
      <div class="row justify-content-center">
        <div class="col-lg-8 col-md-10">
          <div class="footer-content">
            
            <!-- Logo Section -->
            <div class="footer-logo-section">
              <div class="logo-container">
                <img
                  v-if="showLogo"
                  :src="displayLogo"
                  alt="Logo"
                  class="footer-logo"
                  @error="handleLogoError"
                />
                <div v-else class="logo-placeholder">
                  <i class="fa fa-image"></i>
                </div>
              </div>
            </div>

            <!-- Title and Description -->
            <div class="footer-info">
              <h4 class="footer-title">{{ title }}</h4>
              <p v-if="heroDec" class="footer-description">
                {{ heroDec }}
              </p>
            </div>

            <!-- Contact Information -->
            <div class="footer-contact">
              <h5 class="contact-title">تواصل معنا</h5>
              <div class="contact-grid">
                <div class="contact-item">
                  <div class="contact-icon">
                    <i class="fa fa-envelope"></i>
                  </div>
                  <div class="contact-details">
                    <span class="contact-label">البريد الإلكتروني</span>
                    <a :href="'mailto:' + contactEmail" class="contact-link">
                      {{ contactEmail }}
                    </a>
                  </div>
                </div>

                <div class="contact-item">
                  <div class="contact-icon whatsapp">
                    <i class="fa fa-whatsapp"></i>
                  </div>
                  <div class="contact-details">
                    <span class="contact-label">واتساب</span>
                    <a 
                      href="https://wa.me/9647877799669" 
                      class="contact-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {{ contactPhone }}
                    </a>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Footer Bottom -->
      <div class="footer-bottom">
        <div class="footer-divider"></div>
        <div class="copyright-section">
          <p class="copyright-text">
            <i class="fa fa-copyright"></i>
            {{ currentYear }} جميع الحقوق محفوظة لمعاونية شؤون الطبابة والمقاتلين والمضحين
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  position: relative;
  padding: 2rem 0 1rem;
  background: linear-gradient(135deg, #1a5f3f 0%, #0d3d28 100%);
  color: #ffffff;
  overflow: hidden;
}

.footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('@/assets/images/footer-bg.png');
  background-size: cover;
  background-position: center;
  opacity: 0.1;
  z-index: 0;
}

.footer-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    #256c24,
    #256c24 10%
  );
  z-index: 1;
}

.container {
  position: relative;
  z-index: 2;
}

.footer-content {
  text-align: center;
  max-width: 500px;
  margin: 0 auto;
}

/* Logo Section */
.footer-logo-section {
  margin-bottom: 1rem;
}

.logo-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.logo-container:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3);
  background: rgba(255, 255, 255, 0.15);
}

.footer-logo {
  max-width: 50px;
  height: auto;
  filter: brightness(1.1) drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
  transition: all 0.3s ease;
}

.logo-placeholder {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 1.5rem;
}

/* Title and Description */
.footer-info {
  margin-bottom: 1.5rem;
}

.footer-title {
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  line-height: 1.4;
}

.footer-description {
  font-size: 1rem;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 0;
  text-align: center;
}

/* Contact Section */
.footer-contact {
  margin-bottom: 1.5rem;
}

.contact-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #ffffff;
  text-align: center;
  position: relative;
}

.contact-title::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 2px;
  background: linear-gradient(90deg, transparent, #ffffff, #25D366, transparent);
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  max-width: 500px;
  margin: 0 auto;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.8rem;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  text-align: left;
  direction: ltr;
}

.contact-item:hover {
  transform: translateY(-3px);
  background: rgba(255, 255, 255, 0.12);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.contact-icon {
  width: 35px;
  height: 35px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  color: #ffffff;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.contact-icon.whatsapp {
  background: rgba(37, 211, 102, 0.2);
  color: #25D366;
}

.contact-item:hover .contact-icon {
  transform: scale(1.1);
  background: rgba(255, 255, 255, 0.2);
}

.contact-item:hover .contact-icon.whatsapp {
  background: rgba(37, 211, 102, 0.3);
}

.contact-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.contact-label {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
}

.contact-link {
  color: #ffffff;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.85rem;
  transition: all 0.3s ease;
}

.contact-link:hover {
  color: #25D366;
  text-decoration: none;
}

/* Footer Bottom */
.footer-bottom {
  margin-top: 2rem;
}

.footer-divider {
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.3) 20%,
    rgba(255, 255, 255, 0.6) 50%,
    rgba(255, 255, 255, 0.3) 80%,
    transparent 100%
  );
  margin: 2rem auto 1.5rem;
  max-width: 400px;
}

.copyright-section {
  text-align: center;
}

.copyright-text {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  line-height: 1.6;
}

.copyright-text i {
  font-size: 0.8rem;
  opacity: 0.7;
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer {
    padding: 1.5rem 0 1rem;
  }

  .footer-title {
    font-size: 1.2rem;
  }

  .footer-description {
    font-size: 0.9rem;
  }

  .contact-grid {
    grid-template-columns: 1fr;
    gap: 0.8rem;
    max-width: 350px;
  }

  .contact-item {
    padding: 0.7rem;
    flex-direction: column;
    text-align: center;
    gap: 0.6rem;
  }

  .contact-details {
    align-items: center;
  }

  .copyright-text {
    font-size: 0.75rem;
    flex-direction: column;
    gap: 0.3rem;
  }
}

@media (max-width: 480px) {
  .footer-content {
    padding: 0 1rem;
  }

  .footer-logo {
    max-width: 40px;
  }

  .footer-title {
    font-size: 1.1rem;
  }

  .contact-grid {
    grid-template-columns: 1fr;
    max-width: 300px;
  }

  .copyright-text {
    font-size: 0.7rem;
  }
}

/* RTL Support */
[dir="rtl"] .contact-item {
  direction: rtl;
  text-align: right;
}

[dir="rtl"] .contact-link {
  direction: ltr;
  text-align: left;
}

/* Animation for smooth entrance */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.footer-content > * {
  animation: fadeInUp 0.6s ease-out forwards;
}

.footer-logo-section {
  animation-delay: 0.1s;
}

.footer-info {
  animation-delay: 0.2s;
}

.footer-contact {
  animation-delay: 0.3s;
}

.footer-bottom {
  animation-delay: 0.4s;
}
</style>